// Grey Palette
export const grey = {
  50: "#fafafa",
  100: "#f4f4f5",
  200: "#e4e4e7",
  300: "#d4d4d8",
  400: "#a1a1aa",
  450: "#909099",
  500: "#4f5352",
  600: "#363a39",
  700: "#272b2a",
  800: "#1b1f1e",
  900: "#121615",
};

// Primary Palette
export const primary = {
  50: "#f2f4ff",
  100: "#d9e0ff",
  200: "#b0c3ff",
  300: "#809dff",
  400: "#5275ff",
  500: "#2041ff",
  600: "#0013e5",
  700: "#000cb3",
  800: "#000780",
  900: "#00034d",
};

export const libra2Color = primary[600];
export const negativeColor: string = "#F97373";
export const warningColor: string = "#f1c232";

// code block colors
export const codeBlockColor: string = "rgba(0,19,229,0.1)";
export const codeBlockColorClickableOnHover: string = "rgba(0,19,229,0.2)";
// use rgb for codeblock in modal otherwise it will be transparent and not very visible
export const codeBlockColorRgbLight: string = "#E3E8FF";
export const codeBlockColorRgbDark: string = "#1A1F33";
